import { render, staticRenderFns } from "./ViewerPage.vue?vue&type=template&id=2fb520ac&"
import script from "./ViewerPage.vue?vue&type=script&lang=js&"
export * from "./ViewerPage.vue?vue&type=script&lang=js&"
import style0 from "../assets/scss/Viewer.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports